/**
 * Created by Bart Decorte
 * Date: 22/12/2021
 * Time: 10:54
 */
import Filter from './Filter';

export default class DropdownFilter extends Filter {

  select2AjaxConfig() {
    const select = this.optionInput();

    if (!select.dataset.optionsUrl) {
      return null;
    }

    return {
      delay: 200,
      url: select.dataset.optionsUrl,
      processResults: function (data) {
        return {
          results: data.results.map((result) => {
            return {
              id: result.value,
              text: result.name,
            };
          }),
          pagination: data.pagination,
        };
      }
    }
  }

  init() {
    super.init();
    const select = this.optionInput();
    const placeholder = "Choose an option";

    $(select).select2({
      ajax: this.select2AjaxConfig(),
      containerCssClass: select.getAttribute('class'),
      dropdownAutoWidth: true,
      dropdownCssClass: 'dropdown-menu dropdown-menu-right dropdown-menu-sm show',
      placeholder: placeholder,
      width: '100%',
    });
  }

  destroy() {
    const select = this.optionInput();
    $(select).select2('destroy');
    super.destroy();
  }

  optionInput() {
    return this.root.querySelector('.js-option');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/filters/DropdownFilter.js